import { useFetchAuthenticate } from "hooks";
import { getURLWithParams } from "utils/context";

export const useMarketingLives = (params = {}) =>
  useFetchAuthenticate(getURLWithParams("/marketing/lives", params));
